module.exports = __webpack_public_path__ + "img/topup-fail.0f1fc712.png";